import { z } from 'zod';

export const barcodeFormatSchema = z.enum([
  'ean-13',
  'ean-8',
  'code-128',
  'code-39',
  'qr',
  'pdf417',
  'aztec',
  'data-matrix',
  'itf',
  'upc-a',
  'upc-e',
]);
export type BarcodeFormat = z.infer<typeof barcodeFormatSchema>;

export const brandfetchBrandSchema = z.object({
  brandId: z.string(),
  name: z.string(),
  domain: z.string(),
  icon: z.string(),
});
export type BrandfetchBrand = z.infer<typeof brandfetchBrandSchema>;

export const userExternalLoyaltyCardSchema = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  brandfetch_brand_id: z.string().nullable(),
  brand_name: z.string().nullable(),
  brand_domain: z.string().nullable(),
  barcode_value: z.string(),
  barcode_format: barcodeFormatSchema,
  notes: z.string().nullable(),
  created_at: z.string(),
});
export type UserExternalLoyaltyCard = z.infer<typeof userExternalLoyaltyCardSchema>;

export const userExternalLoyaltyCardPreviewSchema = z.object({
  id: z.string().uuid(),
  brand_name: z.string(),
  brand_domain: z.string().nullable(),
  barcode_value: z.string(),
  barcode_format: barcodeFormatSchema,
});
export type UserExternalLoyaltyCardPreview = z.infer<typeof userExternalLoyaltyCardPreviewSchema>;

export const createExternalLoyaltyCardSchema = z.object({
  brandfetch_brand_id: z.string().nullable(),
  brand_name: z.string().min(1),
  brand_domain: z.string().nullable(),
  barcode_value: z.string().min(1),
  barcode_format: barcodeFormatSchema,
  notes: z.string().nullable().optional(),
});
export type CreateExternalLoyaltyCard = z.infer<typeof createExternalLoyaltyCardSchema>;
